module.exports = __webpack_public_path__ + "public/img/jl262.e0a29339.png";